import Cookies from 'js-cookie'

const TokenKey = '5imfg-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getName() {
  return Cookies.get('name')
}

export function setName(name) {
  return Cookies.set('name', name)
}
export function removeName() {
  return Cookies.remove('name')
}
